import * as React from "react";
import classNames from "classnames";
import { useWasSeenByUser } from "@grandvisionhq/analytics";
import { pushPromotionClick, pushPromotionImpression } from "../../../../../../utils/lib-components/RecommendedProducts/utils/data-layer.js";
import { BannerRecommendation } from "../../../../components/lib-components/RecommendedProducts/components/BannerRecommendationBlock/components/BannerRecommendation.js";
/* empty css                               */
const BannerRecommendationBlock = ({
  recommendation,
  shouldRenderAsCard,
  className,
  tabIndex
}) => {
  const clickRef = React.useRef(false);
  const { ref, wasSeen } = useWasSeenByUser();
  const handlePromotionClick = React.useCallback(() => {
    if (!clickRef.current) {
      clickRef.current = true;
      pushPromotionClick(recommendation);
    }
  }, []);
  React.useEffect(() => {
    if (wasSeen) {
      pushPromotionImpression(recommendation);
    }
  }, [wasSeen]);
  return /* @__PURE__ */ React.createElement(
    BannerRecommendation,
    {
      ref,
      onClick: handlePromotionClick,
      recommendation,
      className: classNames(className, "banner-recommendation-block", {
        "banner-recommendation-block--card": shouldRenderAsCard
      }),
      tabIndex
    }
  );
};
export {
  BannerRecommendationBlock
};
//# sourceMappingURL=BannerRecommendationBlock.js.map
